// English-only v1 copy for Owner Readiness & Business Attractiveness prompts

export const ownerReadinessPrompts = [
  'I have a written personal financial plan that shows how I’ll sustain my lifestyle after transition.',
  'I know how much net worth or liquidity I need from the business to achieve my post-exit goals.',
  'I have clearly defined what I want to do personally and professionally after exit.',
  'My family and key stakeholders are aligned with my exit timeline.',
  'I am emotionally ready to reduce or step away from day-to-day business involvement.',
  'I have estate and tax planning strategies in place for transition.',
];

export const businessAttractivenessPrompts = [
  'My business has sustainable revenue growth and healthy margins compared to industry peers.',
  'A significant portion of our revenue is recurring or contractual.',
  'The company is not overly dependent on me; there is a strong management team in place.',
  'Our customer base is diverse and not concentrated in just a few accounts.',
  'We have a defensible market position (brand, niche, or competitive moat).',
  'We have documented and repeatable systems, processes, and governance that support scalability.',
];

export function getDiagnosticPrompt(index) {
  if (index < 6) return ownerReadinessPrompts[index];
  return businessAttractivenessPrompts[index - 6];
}


